import { React, useEffect } from "react";
import AuthHeader from "../../components/headers/authHeader/AuthHeader";
import Footer from "../../components/common/footer/Footer";
import {
  withSessionValidation,
  withAdminSessionValidation,
} from "../../sessionValidation";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useUser } from "../../storage/UserContext"; // addition of context hook
import styles from "./authLayout.module.css";

const apiUrl = process.env.REACT_APP_URL;

const AuthLayout = ({ children }) => {
  /* The Authenticated Layout is used for logged in users. It gets basic user information from the database, and uses the AuthHeader and Footer components, in addition to the specific viewed page, which is passed as children. */
  const { userData, setUserData } = useUser(); // context hook
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserBasicData = async () => {
      try {
        // First, get the username from the session
        const sessionRes = await axios.get(`${apiUrl}/auth/user`, {
          withCredentials: true,
        });

        if (sessionRes.status === 200 && sessionRes.data.success) {
          const username = sessionRes.data.username;

          // Use the username to get user info
          const userRes = await axios.get(`${apiUrl}/users/basic/${username}`, {
            withCredentials: true,
          });

          if (userRes.status === 200 && userRes.data.success) {
            setUserData({
              img_link: userRes.data.img_link,
              is_online: userRes.data.is_online,
              role: userRes.data.role,
              username: username,
            });
          } else {
            // If session is not valid, navigate to public page
            window.location.href = "/";
          }
        }
      } catch (e) {
        console.error("Failed to fetch profile data", e);
        // In case of error, navigate to public page
        window.location.href = "/";
      }
    };

    fetchUserBasicData();
  }, [navigate, setUserData]);

  return (
    <div className={styles.main}>
      <AuthHeader
        imgLink={userData.img_link}
        username={userData.username}
        role={userData.role}
        is_online={userData.is_online}
      />
      {children}
      <Footer isLoggedIn={true} />
    </div>
  );
};

/**
 * Session validation - for an ordinary user, or an admin.
 */
const withValidation = (Component) => {
  return (props) => {
    const { requiredRole } = props;
    if (requiredRole === "Admin") {
      return withAdminSessionValidation(Component)(props);
    }
    return withSessionValidation(Component)(props);
  };
};

export default withValidation(AuthLayout);
